module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/store_images/2_f7cdda1d2dd768eb71febbd205cd9382.png";